/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vc_Onl_WebglInputs */

const en_vc_onl_webgl = /** @type {(inputs: Vc_Onl_WebglInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Blank screen? Try compatibility mode`)
};

const zh_vc_onl_webgl = /** @type {(inputs: Vc_Onl_WebglInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`白屏或黑屏？试试兼容模式`)
};

/**
* | output |
* | --- |
* | "Blank screen? Try compatibility mode" |
*
* @param {Vc_Onl_WebglInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const vc_onl_webgl = /** @type {((inputs?: Vc_Onl_WebglInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vc_Onl_WebglInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_vc_onl_webgl(inputs)
	return zh_vc_onl_webgl(inputs)
});
export { vc_onl_webgl as "vc.onl.webgl" }